module.exports = __webpack_public_path__ + "images/help/icon-twr45-38ca172dde1ecd4b97f3ad6f183292b9.png";